import { render, staticRenderFns } from "./gj-select-input.vue?vue&type=template&id=1a8615ba&scoped=true&"
import script from "./gj-select-input.vue?vue&type=script&lang=js&"
export * from "./gj-select-input.vue?vue&type=script&lang=js&"
import style0 from "./gj-select-input.vue?vue&type=style&index=0&id=1a8615ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8615ba",
  null
  
)

export default component.exports